import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable } from "rxjs";
import { UserService } from '../services/user.service';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
  constructor(private readonly _userService: UserService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.addAccessTokenToRequest(request));
  }

  private addAccessTokenToRequest(request: HttpRequest<any>): HttpRequest<any> {
    const userInfo = this._userService.getUserInfo();
    //console.log(userInfo);
    if (!userInfo)
      return request;

    const accessToken = userInfo.accessToken;
    //console.log('accesstoken:' + accessToken);
    if (!accessToken)
      return request;

    return request.clone({
      setHeaders: {
        "Authorization": `Bearer ${accessToken}`,
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT',
        'If-Modified-Since': '0'
      }
    });
  }
}
